// // src/pages/treatments/DentalPage.jsx
// import React from "react";
// import TreatmentTemplate from "./TreatmentTemplate";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";

// const DENTAL_TREATMENT = {
//   slug: "dental-care",
//   name: "Dental Care & Treatment",
//   shortName: "Dental Care",
//   tagline: "A Perfect Smile. Expert Dentistry. Lasting Confidence.",
//   heroSubtag:
//     "World-class dental care at a fraction of Western costs. India's top specialist dentists. Outstanding aesthetic and functional results.",
//   description:
//     "Comprehensive dental care covering dental implants, full mouth rehabilitation, smile makeovers, cosmetic dentistry, orthodontics, root canal treatment, periodontics and oral surgery — supported by advanced digital dentistry, 3D imaging and same-day restorations. Our specialist dental teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional aesthetic and functional outcomes.",
//   heroImage: "/DentalCare.jpeg",
//   category: "Dental Care",
//   badge: "Advanced Dental Care",
//   accentColor: "blue",
//   costCard: {
//     label: "Dental treatment packages from",
//     value: "₹15K–₹3L",
//     compare: "vs. £2,000–£20,000 in the UK",
//     stay: "Typically 7–21 days in India depending on treatment",
//     stayCompare: "vs. $3,000–$30,000 in the USA",
//   },
//   stats: [
//     { label: "Patient Satisfaction", value: "99%+", icon: Award },
//     { label: "Procedures Performed", value: "60,000+", icon: Users },
//     { label: "Years Experience", value: "20+", icon: Shield },
//     { label: "Dental Specialties", value: "10+", icon: Clock },
//   ],
//   benefits: [
//     "Digital smile design — visualise your new smile before treatment begins",
//     "Same-day crowns and veneers using CAD/CAM CEREC technology",
//     "Nobel Biocare, Straumann and Osstem implant systems",
//     "Full mouth rehabilitation in a single coordinated visit",
//     "Painless dentistry — conscious sedation and topical anaesthesia protocols",
//     "Invisalign, ceramic braces and lingual orthodontics",
//     "Laser dentistry — gum contouring, teeth whitening and cavity treatment",
//     "All-on-4 and All-on-6 fixed implant bridges — same-day teeth",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Consultation & Digital Planning",
//       desc: "Comprehensive oral examination, digital X-rays, CBCT 3D scan, intraoral digital impressions and digital smile design simulation.",
//       duration: "1–2 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Treatment Planning",
//       desc: "Detailed written treatment plan with itemised costs, treatment sequence, timeline and all material and implant brand options presented for your approval.",
//       duration: "1 Day",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Active Treatment",
//       desc: "Dental procedures performed by specialist dentists in sequence — implants, root canals, crowns, veneers or orthodontic appliance fitting as per your plan.",
//       duration: "3–18 Days",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Completion & Review",
//       desc: "Final fitting and adjustment of restorations, oral hygiene instruction, maintenance protocol and telemedicine follow-up after returning home.",
//       duration: "1–2 Days",
//       icon: Heart,
//     },
//   ],
//   faqs: [
//     {
//       q: "What dental treatments are available in India?",
//       a: "India offers the complete range of dental treatments including dental implants (single, multiple, All-on-4, All-on-6), full mouth rehabilitation, porcelain veneers, zirconia crowns, smile makeovers, teeth whitening, root canal treatment, periodontal (gum) surgery, wisdom tooth extraction, orthodontics (Invisalign, ceramic braces, lingual braces), jaw surgery (orthognathic surgery) and cleft palate dental rehabilitation.",
//     },
//     {
//       q: "What is All-on-4 dental implants?",
//       a: "All-on-4 is a fixed full-arch implant bridge supported by just four strategically placed implants — eliminating the need for individual implants for every missing tooth. In most cases, temporary fixed teeth are fitted on the same day as implant surgery. The final zirconia or porcelain bridge is fitted 3–6 months later when implants have fully integrated. All-on-4 is ideal for patients with multiple missing teeth or those currently wearing full dentures.",
//     },
//     {
//       q: "How long do dental implants last?",
//       a: "With proper care and maintenance, dental implants last 20–30 years or a lifetime in the majority of patients. The titanium implant fuses permanently with the jawbone (osseointegration). The crown on top typically lasts 10–15 years before replacement may be needed. Success rates at 10 years exceed 95% at high-volume implant centres using Nobel Biocare or Straumann systems.",
//     },
//     {
//       q: "What is digital smile design?",
//       a: "Digital smile design (DSD) uses photographs and digital software to design your ideal smile — adjusting tooth shape, size, colour and gum line — before any treatment begins. The design is shared with the dental laboratory to fabricate your restorations and can be previewed as a wax mock-up in your mouth before any teeth are prepared. This ensures your final result matches your expectations precisely.",
//     },
//     {
//       q: "Can I complete a full mouth rehabilitation in one visit to India?",
//       a: "Yes. Most full mouth rehabilitation cases — implants, crowns, veneers and gum treatment — can be completed or significantly advanced in a single 14–21 day visit. Implant osseointegration requires 3–6 months, so patients with implants typically make two visits: implant placement on the first visit and final crown fitting 3–6 months later. Temporary crowns and provisional restorations are provided between visits.",
//     },
//     {
//       q: "Is dental treatment in India safe and hygienic?",
//       a: "Yes. Accredited Indian dental hospitals follow sterilisation and infection control protocols identical to those in the UK, USA or Australia — autoclave sterilisation, single-use instruments, barrier techniques and documented sterilisation records. PaxGrow only partners with ISO-certified and NABH-accredited dental centres. All materials, implants and porcelain used are internationally certified brands.",
//     },
//     {
//       q: "What is the cost of dental treatment in India vs. the UK or USA?",
//       a: "Dental treatment in India costs 60–80% less than in the UK or USA. A single dental implant (Nobel Biocare) costs ₹35K–₹60K vs £2,000–£3,500 in the UK. Porcelain veneers cost ₹12K–₹20K each vs £800–£1,200 each in the UK. All-on-4 full arch costs ₹2.5L–₹4L per arch vs £12,000–£20,000 per arch in the UK — using identical international implant systems and porcelain.",
//     },
//     {
//       q: "How soon can I fly home after dental treatment?",
//       a: "For most dental procedures — crowns, veneers, root canals, teeth whitening — you can fly home the same day as treatment completion. After dental implant surgery, it is advisable to wait 48–72 hours before flying to allow initial healing. After full mouth surgery under general anaesthesia or IV sedation, 3–5 days rest is recommended before flying. PaxGrow arranges your appointment schedule to fit your travel dates.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Sunita Verma",
//       specialty: "Implantology & Full Mouth Rehabilitation",
//       experience: "22 Years",
//       rating: 4.9,
//       reviews: 3800,
//       image: "https://randomuser.me/api/portraits/women/44.jpg",
//       qualifications: "BDS, MDS (Prosthodontics), Fellowship Implantology (Germany)",
//       hospital: "Clove Dental, New Delhi",
//     },
//     {
//       name: "Dr. Kunal Brahmbhatt",
//       specialty: "Cosmetic Dentistry & Smile Design",
//       experience: "18 Years",
//       rating: 4.9,
//       reviews: 2900,
//       image: "https://randomuser.me/api/portraits/men/63.jpg",
//       qualifications: "BDS, MDS (Conservative Dentistry), LVIF (Las Vegas)",
//       hospital: "Dentzz Dental, Mumbai",
//     },
//     {
//       name: "Dr. Anisha Mehta",
//       specialty: "Orthodontics & Invisalign",
//       experience: "16 Years",
//       rating: 4.8,
//       reviews: 2400,
//       image: "https://randomuser.me/api/portraits/women/55.jpg",
//       qualifications: "BDS, MDS (Orthodontics), Invisalign Diamond Provider",
//       hospital: "Apollo White Dental, Chennai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Beatrice Okonkwo",
//       age: 48,
//       location: "Lagos, Nigeria",
//       text: "I had been ashamed of my smile for twenty years — multiple missing teeth and badly discoloured remaining ones. PaxGrow arranged a full mouth rehabilitation at a Delhi clinic over 16 days. Eight implants, twelve zirconia crowns and four veneers. I flew home with the most beautiful smile I have ever had. The total cost including flights and accommodation was less than four implants would have cost me in London.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/68.jpg",
//       treatment: "Full Mouth Rehabilitation — Implants, Crowns & Veneers",
//       date: "October 2023",
//     },
//     {
//       name: "Yusuf Al-Rashid",
//       age: 55,
//       location: "Riyadh, Saudi Arabia",
//       text: "Both my upper and lower arches were completely edentulous. I had been wearing dentures for eight years. The All-on-4 surgery in Mumbai was done under IV sedation — I felt nothing. I woke up with fixed teeth. The zirconia final bridge was fitted on my second visit three months later. I can eat anything I want. My confidence has returned completely.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/61.jpg",
//       treatment: "All-on-4 Full Arch Implants — Upper & Lower",
//       date: "December 2023",
//     },
//     {
//       name: "Priya Fernandes",
//       age: 29,
//       location: "Nairobi, Kenya",
//       text: "I had always wanted a smile makeover but the quotes in Nairobi and London were completely out of reach. PaxGrow found me a cosmetic dentist in Chennai who used digital smile design to plan my ten veneers precisely. The result is completely natural — nobody can tell they are veneers. The cost was one quarter of the London quote and the quality is outstanding.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/32.jpg",
//       treatment: "Smile Makeover — 10 Porcelain Veneers & Teeth Whitening",
//       date: "February 2024",
//     },
//   ],
// };

// const DENTAL_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Dental Care",
//   whyIndiaReasons: [
//     "ISO-certified and NABH-accredited dental centres with CBCT 3D imaging, CAD/CAM same-day crowns, digital smile design and Nobel Biocare, Straumann implant systems",
//     "MDS-qualified specialist dentists — prosthodontists, implantologists, orthodontists and periodontists — with international fellowship training and 500–2,000 cases per year",
//     "Appointments confirmed within 3–5 days of arrival — complete treatment plans delivered within 48 hours of first consultation",
//     "Clove Dental, Dentzz, Apollo White Dental, Sabka Dentist, Vijay Dental — nationally accredited networks with consistent clinical standards across all centres",
//   ],
//   conditionsTitle: "Dental Conditions & Procedures We Facilitate",
//   conditions: [
//     "Missing Teeth — Single & Multiple Implants",
//     "Full Mouth Rehabilitation",
//     "All-on-4 & All-on-6 Implant Bridges",
//     "Porcelain Veneers & Smile Makeover",
//     "Zirconia & Ceramic Crowns",
//     "Root Canal Treatment",
//     "Periodontal (Gum) Disease Treatment",
//     "Teeth Whitening & Bleaching",
//     "Invisalign & Ceramic Braces",
//     "Wisdom Tooth Extraction",
//     "Jaw Surgery (Orthognathic Surgery)",
//     "Cleft Palate Dental Rehabilitation",
//   ],
//   stayValue:
//     "Simple procedures: 3–5 days · Smile makeover & crowns: 7–10 days · Full mouth rehabilitation: 14–21 days · All-on-4 implants: 5–7 days (first visit) + 3–5 days (final bridge visit)",
//   costTitle: "Why India for Dental Treatment?",
//   costRows: [
//     {
//       procedure: "Single Dental Implant (Nobel Biocare)",
//       india: "₹35K–₹60K",
//       africa: "$1,500–$3,000",
//       ukusa: "$3,000–$6,000",
//     },
//     {
//       procedure: "All-on-4 Full Arch Implants",
//       india: "₹2.5L–₹4L",
//       africa: "$8,000–$15,000",
//       ukusa: "$15,000–$28,000",
//     },
//     {
//       procedure: "Porcelain Veneer (per tooth)",
//       india: "₹12K–₹20K",
//       africa: "$400–$900",
//       ukusa: "$1,000–$2,500",
//     },
//     {
//       procedure: "Zirconia Crown (per tooth)",
//       india: "₹8K–₹18K",
//       africa: "$300–$800",
//       ukusa: "$1,000–$2,000",
//     },
//     {
//       procedure: "Full Mouth Rehabilitation",
//       india: "₹1.5L–₹4L",
//       africa: "$8,000–$20,000",
//       ukusa: "$20,000–$50,000",
//     },
//   ],
// };

// const DentalPage = () => {
//   return (
//     <TreatmentTemplate
//       treatment={DENTAL_TREATMENT}
//       paxgrowData={DENTAL_PAXGROW}
//     />
//   );
// };

// export default DentalPage;

// // src/pages/treatments/DentalPage.jsx
// import React from "react";
// import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";
// import TreatmentTemplateForDental from "./TreatmentTemplateForDental";

// const DENTAL_TREATMENT = {
//   slug: "dental-care",
//   name: "Dental Care & Treatment",
//   shortName: "Dental Care",
//   tagline: "A Perfect Smile. Expert Dentistry. Lasting Confidence.",
//   heroSubtag:
//     "World-class dental care at a fraction of Western costs. India's top specialist dentists. Outstanding aesthetic and functional results.",
//   description:
//     "Comprehensive dental care covering dental implants, full mouth rehabilitation, smile makeovers, cosmetic dentistry, orthodontics, root canal treatment, periodontics and oral surgery — supported by advanced digital dentistry, 3D imaging and same-day restorations. Our specialist dental teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional aesthetic and functional outcomes.",
//   heroImage: "/DentalCare.jpeg",
//   category: "Dental Care",
//   badge: "Advanced Dental Care",
//   accentColor: "blue",
//   costCard: {
//     label: "Dental treatment packages from",
//     value: "₹15K–₹3L",
//     compare: "vs. £2,000–£20,000 in the UK",
//     stay: "Typically 7–21 days in India depending on treatment",
//     stayCompare: "vs. $3,000–$30,000 in the USA",
//   },
//   stats: [
//     { label: "Patient Satisfaction", value: "99%+", icon: Award },
//     { label: "Procedures Performed", value: "60,000+", icon: Users },
//     { label: "Years Experience", value: "20+", icon: Shield },
//     { label: "Dental Specialties", value: "10+", icon: Clock },
//   ],
//   benefits: [
//     "Digital smile design — visualise your new smile before treatment begins",
//     "Same-day crowns and veneers using CAD/CAM CEREC technology",
//     "Nobel Biocare, Straumann and Osstem implant systems",
//     "Full mouth rehabilitation in a single coordinated visit",
//     "Painless dentistry — conscious sedation and topical anaesthesia protocols",
//     "Invisalign, ceramic braces and lingual orthodontics",
//     "Laser dentistry — gum contouring, teeth whitening and cavity treatment",
//     "All-on-4 and All-on-6 fixed implant bridges — same-day teeth",
//   ],
//   procedure: [
//     {
//       step: "01",
//       title: "Consultation & Digital Planning",
//       desc: "Comprehensive oral examination, digital X-rays, CBCT 3D scan, intraoral digital impressions and digital smile design simulation.",
//       duration: "1–2 Days",
//       icon: Calendar,
//     },
//     {
//       step: "02",
//       title: "Treatment Planning",
//       desc: "Detailed written treatment plan with itemised costs, treatment sequence, timeline and all material and implant brand options presented for your approval.",
//       duration: "1 Day",
//       icon: Activity,
//     },
//     {
//       step: "03",
//       title: "Active Treatment",
//       desc: "Dental procedures performed by specialist dentists in sequence — implants, root canals, crowns, veneers or orthodontic appliance fitting as per your plan.",
//       duration: "3–18 Days",
//       icon: ThumbsUp,
//     },
//     {
//       step: "04",
//       title: "Completion & Review",
//       desc: "Final fitting and adjustment of restorations, oral hygiene instruction, maintenance protocol and telemedicine follow-up after returning home.",
//       duration: "1–2 Days",
//       icon: Heart,
//     },
//   ],
//   // ── TREATMENT PHOTOS ──────────────────────────────
//   treatmentPhotos: [
//     {
//       src: "/Root Canal.jpg",
//       label: "Root Canal Treatment",
//       tag: "Endodontics",
//     },
//     {
//       src: "/Veneers.jpg",
//       label: "Porcelain Veneers",
//       tag: "Cosmetic Dentistry",
//     },
//     {
//       src: "/Grillz.jpg",
//       label: "Smile Makeover",
//       tag: "Aesthetic Dentistry",
//     },
//   ],
//   faqs: [
//     {
//       q: "What dental treatments are available in India?",
//       a: "India offers the complete range of dental treatments including dental implants (single, multiple, All-on-4, All-on-6), full mouth rehabilitation, porcelain veneers, zirconia crowns, smile makeovers, teeth whitening, root canal treatment, periodontal (gum) surgery, wisdom tooth extraction, orthodontics (Invisalign, ceramic braces, lingual braces), jaw surgery (orthognathic surgery) and cleft palate dental rehabilitation.",
//     },
//     {
//       q: "What is All-on-4 dental implants?",
//       a: "All-on-4 is a fixed full-arch implant bridge supported by just four strategically placed implants — eliminating the need for individual implants for every missing tooth. In most cases, temporary fixed teeth are fitted on the same day as implant surgery. The final zirconia or porcelain bridge is fitted 3–6 months later when implants have fully integrated. All-on-4 is ideal for patients with multiple missing teeth or those currently wearing full dentures.",
//     },
//     {
//       q: "How long do dental implants last?",
//       a: "With proper care and maintenance, dental implants last 20–30 years or a lifetime in the majority of patients. The titanium implant fuses permanently with the jawbone (osseointegration). The crown on top typically lasts 10–15 years before replacement may be needed. Success rates at 10 years exceed 95% at high-volume implant centres using Nobel Biocare or Straumann systems.",
//     },
//     {
//       q: "What is digital smile design?",
//       a: "Digital smile design (DSD) uses photographs and digital software to design your ideal smile — adjusting tooth shape, size, colour and gum line — before any treatment begins. The design is shared with the dental laboratory to fabricate your restorations and can be previewed as a wax mock-up in your mouth before any teeth are prepared. This ensures your final result matches your expectations precisely.",
//     },
//     {
//       q: "Can I complete a full mouth rehabilitation in one visit to India?",
//       a: "Yes. Most full mouth rehabilitation cases — implants, crowns, veneers and gum treatment — can be completed or significantly advanced in a single 14–21 day visit. Implant osseointegration requires 3–6 months, so patients with implants typically make two visits: implant placement on the first visit and final crown fitting 3–6 months later. Temporary crowns and provisional restorations are provided between visits.",
//     },
//     {
//       q: "Is dental treatment in India safe and hygienic?",
//       a: "Yes. Accredited Indian dental hospitals follow sterilisation and infection control protocols identical to those in the UK, USA or Australia — autoclave sterilisation, single-use instruments, barrier techniques and documented sterilisation records. PaxGrow only partners with ISO-certified and NABH-accredited dental centres. All materials, implants and porcelain used are internationally certified brands.",
//     },
//     {
//       q: "What is the cost of dental treatment in India vs. the UK or USA?",
//       a: "Dental treatment in India costs 60–80% less than in the UK or USA. A single dental implant (Nobel Biocare) costs ₹35K–₹60K vs £2,000–£3,500 in the UK. Porcelain veneers cost ₹12K–₹20K each vs £800–£1,200 each in the UK. All-on-4 full arch costs ₹2.5L–₹4L per arch vs £12,000–£20,000 per arch in the UK — using identical international implant systems and porcelain.",
//     },
//     {
//       q: "How soon can I fly home after dental treatment?",
//       a: "For most dental procedures — crowns, veneers, root canals, teeth whitening — you can fly home the same day as treatment completion. After dental implant surgery, it is advisable to wait 48–72 hours before flying to allow initial healing. After full mouth surgery under general anaesthesia or IV sedation, 3–5 days rest is recommended before flying. PaxGrow arranges your appointment schedule to fit your travel dates.",
//     },
//   ],
//   doctors: [
//     {
//       name: "Dr. Sunita Verma",
//       specialty: "Implantology & Full Mouth Rehabilitation",
//       experience: "22 Years",
//       rating: 4.9,
//       reviews: 3800,
//       image: "https://randomuser.me/api/portraits/women/44.jpg",
//       qualifications: "BDS, MDS (Prosthodontics), Fellowship Implantology (Germany)",
//       hospital: "Clove Dental, New Delhi",
//     },
//     {
//       name: "Dr. Kunal Brahmbhatt",
//       specialty: "Cosmetic Dentistry & Smile Design",
//       experience: "18 Years",
//       rating: 4.9,
//       reviews: 2900,
//       image: "https://randomuser.me/api/portraits/men/63.jpg",
//       qualifications: "BDS, MDS (Conservative Dentistry), LVIF (Las Vegas)",
//       hospital: "Dentzz Dental, Mumbai",
//     },
//     {
//       name: "Dr. Anisha Mehta",
//       specialty: "Orthodontics & Invisalign",
//       experience: "16 Years",
//       rating: 4.8,
//       reviews: 2400,
//       image: "https://randomuser.me/api/portraits/women/55.jpg",
//       qualifications: "BDS, MDS (Orthodontics), Invisalign Diamond Provider",
//       hospital: "Apollo White Dental, Chennai",
//     },
//   ],
//   testimonials: [
//     {
//       name: "Beatrice Okonkwo",
//       age: 48,
//       location: "Lagos, Nigeria",
//       text: "I had been ashamed of my smile for twenty years — multiple missing teeth and badly discoloured remaining ones. PaxGrow arranged a full mouth rehabilitation at a Delhi clinic over 16 days. Eight implants, twelve zirconia crowns and four veneers. I flew home with the most beautiful smile I have ever had. The total cost including flights and accommodation was less than four implants would have cost me in London.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/68.jpg",
//       treatment: "Full Mouth Rehabilitation — Implants, Crowns & Veneers",
//       date: "October 2023",
//     },
//     {
//       name: "Yusuf Al-Rashid",
//       age: 55,
//       location: "Riyadh, Saudi Arabia",
//       text: "Both my upper and lower arches were completely edentulous. I had been wearing dentures for eight years. The All-on-4 surgery in Mumbai was done under IV sedation — I felt nothing. I woke up with fixed teeth. The zirconia final bridge was fitted on my second visit three months later. I can eat anything I want. My confidence has returned completely.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/men/61.jpg",
//       treatment: "All-on-4 Full Arch Implants — Upper & Lower",
//       date: "December 2023",
//     },
//     {
//       name: "Priya Fernandes",
//       age: 29,
//       location: "Nairobi, Kenya",
//       text: "I had always wanted a smile makeover but the quotes in Nairobi and London were completely out of reach. PaxGrow found me a cosmetic dentist in Chennai who used digital smile design to plan my ten veneers precisely. The result is completely natural — nobody can tell they are veneers. The cost was one quarter of the London quote and the quality is outstanding.",
//       rating: 5,
//       image: "https://randomuser.me/api/portraits/women/32.jpg",
//       treatment: "Smile Makeover — 10 Porcelain Veneers & Teeth Whitening",
//       date: "February 2024",
//     },
//   ],
// };

// const DENTAL_PAXGROW = {
//   whyIndiaSubtitle: "WHY PAXGROW + INDIA",
//   whyIndiaTitle: "Why African & Gulf Patients Choose India for Dental Care",
//   whyIndiaReasons: [
//     "ISO-certified and NABH-accredited dental centres with CBCT 3D imaging, CAD/CAM same-day crowns, digital smile design and Nobel Biocare, Straumann implant systems",
//     "MDS-qualified specialist dentists — prosthodontists, implantologists, orthodontists and periodontists — with international fellowship training and 500–2,000 cases per year",
//     "Appointments confirmed within 3–5 days of arrival — complete treatment plans delivered within 48 hours of first consultation",
//     "Clove Dental, Dentzz, Apollo White Dental, Sabka Dentist, Vijay Dental — nationally accredited networks with consistent clinical standards across all centres",
//   ],
//   conditionsTitle: "Dental Conditions & Procedures We Facilitate",

//   // ── CATEGORISED CONDITIONS (dental-specific) ──────
//   categorisedConditions: [
//     {
//       category: "Dental Implants & Restorative Dentistry",
//       icon: "🦷",
//       color: "blue",
//       items: [
//         {
//           name: "Single & Multiple Dental Implants",
//           desc: "High-quality titanium or zirconia implants to replace missing teeth.",
//         },
//         {
//           name: "Full-Mouth Rehabilitation",
//           desc: "Comprehensive reconstruction for severely decayed or worn-out teeth, using implants, bridges, or overdentures.",
//         },
//         {
//           name: "All-on-4 / All-on-6 Implants",
//           desc: "Full arch restorations fixed on a minimal number of implants, frequently completed in one or two visits.",
//         },
//         {
//           name: "Crowns & Bridges",
//           desc: "Ceramic, porcelain, or zirconia caps to strengthen damaged teeth or replace gaps.",
//         },
//       ],
//     },
//     {
//       category: "Cosmetic Dentistry & Smile Design",
//       icon: "✨",
//       color: "amber",
//       items: [
//         {
//           name: "Porcelain Veneers & Smile Makeover",
//           desc: "Ultra-thin porcelain shells bonded to the front surface of teeth for an instant smile transformation.",
//         },
//         {
//           name: "Zirconia & Ceramic Crowns",
//           desc: "Metal-free, natural-looking crowns with superior strength and aesthetics.",
//         },
//         {
//           name: "Teeth Whitening & Bleaching",
//           desc: "Professional in-chair laser whitening and take-home bleaching kits for a brighter smile.",
//         },
//       ],
//     },
//     {
//       category: "Orthodontics",
//       icon: "📐",
//       color: "violet",
//       items: [
//         {
//           name: "Clear Aligners (Invisalign)",
//           desc: "Discreet, removable aligners heavily favoured by travelling patients for straightening teeth.",
//         },
//         {
//           name: "Ceramic Braces",
//           desc: "Cost-effective tooth-coloured braces for a more aesthetic orthodontic option.",
//         },
//       ],
//     },
//     {
//       category: "Endodontics & Periodontics",
//       icon: "🔬",
//       color: "green",
//       items: [
//         {
//           name: "Root Canal Treatment (RCT)",
//           desc: "Modern single-sitting or multi-sitting painless root canals utilising digital X-rays and lasers.",
//         },
//         {
//           name: "Periodontal (Gum) Disease Treatment",
//           desc: "Specialised care including flap surgery, laser gum contouring, and LANAP.",
//         },
//       ],
//     },
//     {
//       category: "Oral & Maxillofacial Surgery",
//       icon: "🏥",
//       color: "rose",
//       items: [
//         {
//           name: "Wisdom Tooth Extraction",
//           desc: "Routine or complex surgical removal of impacted wisdom teeth.",
//         },
//         {
//           name: "Jaw Surgery (Orthognathic Surgery)",
//           desc: "Corrective procedures for jaw alignment, temporomandibular joint disorders or facial trauma.",
//         },
//         {
//           name: "Cleft Palate Dental Rehabilitation",
//           desc: "Specialised multi-disciplinary dental rehabilitation for patients with cleft palate.",
//         },
//       ],
//     },
//   ],

//   // flat list kept for the stay banner & legacy use
//   conditions: [
//     "Missing Teeth — Single & Multiple Implants",
//     "Full Mouth Rehabilitation",
//     "All-on-4 & All-on-6 Implant Bridges",
//     "Porcelain Veneers & Smile Makeover",
//     "Zirconia & Ceramic Crowns",
//     "Root Canal Treatment",
//     "Periodontal (Gum) Disease Treatment",
//     "Teeth Whitening & Bleaching",
//     "Invisalign & Ceramic Braces",
//     "Wisdom Tooth Extraction",
//     "Jaw Surgery (Orthognathic Surgery)",
//     "Cleft Palate Dental Rehabilitation",
//   ],

//   // ── UPDATED STAY VALUE ────────────────────────────
//   stayValue:
//     "Simple procedures: 3–5 days · Smile makeover & crowns: 7–10 days · Full mouth rehabilitation: 14–21 days (Multiple visits may be needed for implants depending on Requirements) · All-on-4 implants: 5–7 days (first visit) + 3–5 days (final bridge visit)",

//   costTitle: "Why India for Dental Treatment?",
//   costRows: [
//     {
//       procedure: "Single Dental Implant (Nobel Biocare)",
//       india: "₹35K–₹60K",
//       africa: "$1,500–$3,000",
//       ukusa: "$3,000–$6,000",
//     },
//     {
//       procedure: "All-on-4 Full Arch Implants",
//       india: "₹2.5L–₹4L",
//       africa: "$8,000–$15,000",
//       ukusa: "$15,000–$28,000",
//     },
//     {
//       procedure: "Porcelain Veneer (per tooth)",
//       india: "₹12K–₹20K",
//       africa: "$400–$900",
//       ukusa: "$1,000–$2,500",
//     },
//     {
//       procedure: "Zirconia Crown (per tooth)",
//       india: "₹8K–₹18K",
//       africa: "$300–$800",
//       ukusa: "$1,000–$2,000",
//     },
//     {
//       procedure: "Full Mouth Rehabilitation",
//       india: "₹1.5L–₹4L",
//       africa: "$8,000–$20,000",
//       ukusa: "$20,000–$50,000",
//     },
//   ],
// };

// const DentalPage = () => {
//   return (
//     <TreatmentTemplateForDental
//       treatment={DENTAL_TREATMENT}
//       paxgrowData={DENTAL_PAXGROW}
//     />
//   );
// };

// export default DentalPage;

// src/pages/treatments/DentalPage.jsx
import React from "react";
import { Award, Users, Shield, Clock, Calendar, Activity, ThumbsUp, Heart } from "lucide-react";
import TreatmentTemplateForDental from "./TreatmentTemplateForDental";

const DENTAL_TREATMENT = {
  slug: "dental-care",
  name: "Dental Care & Treatment",
  shortName: "Dental Care",
  tagline: "A Perfect Smile. Expert Dentistry. Lasting Confidence.",
  heroSubtag:
    "World-class dental care at a fraction of Western costs. India's top specialist dentists. Outstanding aesthetic and functional results.",
  description:
    "Comprehensive dental care covering dental implants, full mouth rehabilitation, smile makeovers, cosmetic dentistry, orthodontics, root canal treatment, periodontics and oral surgery — supported by advanced digital dentistry, 3D imaging and same-day restorations. Our specialist dental teams review every case to deliver globally benchmarked, personalised treatment plans with exceptional aesthetic and functional outcomes.",
  heroImage: "/DentalCare.jpg",
  category: "Dental Care",
  badge: "Advanced Dental Care",
  accentColor: "blue",
  costCard: {
    label: "Dental treatment packages from",
    value: "$180–$3,600",
    compare: "vs. $2,500–$25,000 in the UK",
    stay: "Typically 7–21 days in India depending on treatment",
    stayCompare: "vs. $3,000–$30,000 in the USA",
  },
  stats: [
    { label: "Patient Satisfaction", value: "99%+", icon: Award },
    { label: "Procedures Performed", value: "60,000+", icon: Users },
    { label: "Years Experience", value: "20+", icon: Shield },
    { label: "Dental Specialties", value: "10+", icon: Clock },
  ],
  benefits: [
    "Digital smile design — visualise your new smile before treatment begins",
    "Same-day crowns and veneers using CAD/CAM CEREC technology",
    "Nobel Biocare, Straumann and Osstem implant systems",
    "Full mouth rehabilitation in a single coordinated visit",
    "Painless dentistry — conscious sedation and topical anaesthesia protocols",
    "Invisalign, ceramic braces and lingual orthodontics",
    "Laser dentistry — gum contouring, teeth whitening and cavity treatment",
    "All-on-4 and All-on-6 fixed implant bridges — same-day teeth",
  ],
  procedure: [
    {
      step: "01",
      title: "Consultation & Digital Planning",
      desc: "Comprehensive oral examination, digital X-rays, CBCT 3D scan, intraoral digital impressions and digital smile design simulation.",
      duration: "1–2 Days",
      icon: Calendar,
    },
    {
      step: "02",
      title: "Treatment Planning",
      desc: "Detailed written treatment plan with itemised costs, treatment sequence, timeline and all material and implant brand options presented for your approval.",
      duration: "1 Day",
      icon: Activity,
    },
    {
      step: "03",
      title: "Active Treatment",
      desc: "Dental procedures performed by specialist dentists in sequence — implants, root canals, crowns, veneers or orthodontic appliance fitting as per your plan.",
      duration: "3–18 Days",
      icon: ThumbsUp,
    },
    {
      step: "04",
      title: "Completion & Review",
      desc: "Final fitting and adjustment of restorations, oral hygiene instruction, maintenance protocol and telemedicine follow-up after returning home.",
      duration: "1–2 Days",
      icon: Heart,
    },
  ],
  // ── TREATMENT PHOTOS ──────────────────────────────
  treatmentPhotos: [
    {
      src: "/Root Canal.jpg",
      label: "Root Canal Treatment",
      tag: "Endodontics",
    },
    {
      src: "/Veneers.jpg",
      label: "Porcelain Veneers",
      tag: "Cosmetic Dentistry",
    },
    {
      src: "/Grillz.jpg",
      label: "Smile Makeover",
      tag: "Aesthetic Dentistry",
    },
  ],
  faqs: [
    {
      q: "What dental treatments are available in India?",
      a: "India offers the complete range of dental treatments including dental implants (single, multiple, All-on-4, All-on-6), full mouth rehabilitation, porcelain veneers, zirconia crowns, smile makeovers, teeth whitening, root canal treatment, periodontal (gum) surgery, wisdom tooth extraction, orthodontics (Invisalign, ceramic braces, lingual braces), jaw surgery (orthognathic surgery) and cleft palate dental rehabilitation.",
    },
    {
      q: "What is All-on-4 dental implants?",
      a: "All-on-4 is a fixed full-arch implant bridge supported by just four strategically placed implants — eliminating the need for individual implants for every missing tooth. In most cases, temporary fixed teeth are fitted on the same day as implant surgery. The final zirconia or porcelain bridge is fitted 3–6 months later when implants have fully integrated. All-on-4 is ideal for patients with multiple missing teeth or those currently wearing full dentures.",
    },
    {
      q: "How long do dental implants last?",
      a: "With proper care and maintenance, dental implants last 20–30 years or a lifetime in the majority of patients. The titanium implant fuses permanently with the jawbone (osseointegration). The crown on top typically lasts 10–15 years before replacement may be needed. Success rates at 10 years exceed 95% at high-volume implant centres using Nobel Biocare or Straumann systems.",
    },
    {
      q: "What is digital smile design?",
      a: "Digital smile design (DSD) uses photographs and digital software to design your ideal smile — adjusting tooth shape, size, colour and gum line — before any treatment begins. The design is shared with the dental laboratory to fabricate your restorations and can be previewed as a wax mock-up in your mouth before any teeth are prepared. This ensures your final result matches your expectations precisely.",
    },
    {
      q: "Can I complete a full mouth rehabilitation in one visit to India?",
      a: "Yes. Most full mouth rehabilitation cases — implants, crowns, veneers and gum treatment — can be completed or significantly advanced in a single 14–21 day visit. Implant osseointegration requires 3–6 months, so patients with implants typically make two visits: implant placement on the first visit and final crown fitting 3–6 months later. Temporary crowns and provisional restorations are provided between visits.",
    },
    {
      q: "Is dental treatment in India safe and hygienic?",
      a: "Yes. Accredited Indian dental hospitals follow sterilisation and infection control protocols identical to those in the UK, USA or Australia — autoclave sterilisation, single-use instruments, barrier techniques and documented sterilisation records. PaxGrow only partners with ISO-certified and NABH-accredited dental centres. All materials, implants and porcelain used are internationally certified brands.",
    },
    {
      q: "What is the cost of dental treatment in India vs. the UK or USA?",
      a: "Dental treatment in India costs 60–80% less than in the UK or USA. A single dental implant (Nobel Biocare) costs $420–$720 vs $2,500–$4,500 in the UK. Porcelain veneers cost $145–$240 each vs $1,000–$1,500 each in the UK. All-on-4 full arch costs $3,000–$4,800 per arch vs $15,000–$25,000 per arch in the UK — using identical international implant systems and porcelain.",
    },
    {
      q: "How soon can I fly home after dental treatment?",
      a: "For most dental procedures — crowns, veneers, root canals, teeth whitening — you can fly home the same day as treatment completion. After dental implant surgery, it is advisable to wait 48–72 hours before flying to allow initial healing. After full mouth surgery under general anaesthesia or IV sedation, 3–5 days rest is recommended before flying. PaxGrow arranges your appointment schedule to fit your travel dates.",
    },
  ],
  doctors: [
    {
      name: "Dr. Sunita Verma",
      specialty: "Implantology & Full Mouth Rehabilitation",
      experience: "22 Years",
      rating: 4.9,
      reviews: 3800,
      image: "https://randomuser.me/api/portraits/women/44.jpg",
      qualifications: "BDS, MDS (Prosthodontics), Fellowship Implantology (Germany)",
      hospital: "Clove Dental, New Delhi",
    },
    {
      name: "Dr. Kunal Brahmbhatt",
      specialty: "Cosmetic Dentistry & Smile Design",
      experience: "18 Years",
      rating: 4.9,
      reviews: 2900,
      image: "https://randomuser.me/api/portraits/men/63.jpg",
      qualifications: "BDS, MDS (Conservative Dentistry), LVIF (Las Vegas)",
      hospital: "Dentzz Dental, Mumbai",
    },
    {
      name: "Dr. Anisha Mehta",
      specialty: "Orthodontics & Invisalign",
      experience: "16 Years",
      rating: 4.8,
      reviews: 2400,
      image: "https://randomuser.me/api/portraits/women/55.jpg",
      qualifications: "BDS, MDS (Orthodontics), Invisalign Diamond Provider",
      hospital: "Apollo White Dental, Chennai",
    },
  ],
  testimonials: [
    {
      name: "Beatrice Okonkwo",
      age: 48,
      location: "Lagos, Nigeria",
      text: "I had been ashamed of my smile for twenty years — multiple missing teeth and badly discoloured remaining ones. PaxGrow arranged a full mouth rehabilitation at a Delhi clinic over 16 days. Eight implants, twelve zirconia crowns and four veneers. I flew home with the most beautiful smile I have ever had. The total cost including flights and accommodation was less than four implants would have cost me in London.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/68.jpg",
      treatment: "Full Mouth Rehabilitation — Implants, Crowns & Veneers",
      date: "October 2023",
    },
    {
      name: "Yusuf Al-Rashid",
      age: 55,
      location: "Riyadh, Saudi Arabia",
      text: "Both my upper and lower arches were completely edentulous. I had been wearing dentures for eight years. The All-on-4 surgery in Mumbai was done under IV sedation — I felt nothing. I woke up with fixed teeth. The zirconia final bridge was fitted on my second visit three months later. I can eat anything I want. My confidence has returned completely.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/men/61.jpg",
      treatment: "All-on-4 Full Arch Implants — Upper & Lower",
      date: "December 2023",
    },
    {
      name: "Priya Fernandes",
      age: 29,
      location: "Nairobi, Kenya",
      text: "I had always wanted a smile makeover but the quotes in Nairobi and London were completely out of reach. PaxGrow found me a cosmetic dentist in Chennai who used digital smile design to plan my ten veneers precisely. The result is completely natural — nobody can tell they are veneers. The cost was one quarter of the London quote and the quality is outstanding.",
      rating: 5,
      image: "https://randomuser.me/api/portraits/women/32.jpg",
      treatment: "Smile Makeover — 10 Porcelain Veneers & Teeth Whitening",
      date: "February 2024",
    },
  ],
};

const DENTAL_PAXGROW = {
  whyIndiaSubtitle: "WHY PAXGROW + INDIA",
  whyIndiaTitle: "Why African & Gulf Patients Choose India for Dental Care",
  whyIndiaReasons: [
    "ISO-certified and NABH-accredited dental centres with CBCT 3D imaging, CAD/CAM same-day crowns, digital smile design and Nobel Biocare, Straumann implant systems",
    "MDS-qualified specialist dentists — prosthodontists, implantologists, orthodontists and periodontists — with international fellowship training and 500–2,000 cases per year",
    "Appointments confirmed within 3–5 days of arrival — complete treatment plans delivered within 48 hours of first consultation",
    "Clove Dental, Dentzz, Apollo White Dental, Sabka Dentist, Vijay Dental — nationally accredited networks with consistent clinical standards across all centres",
  ],
  conditionsTitle: "Dental Conditions & Procedures We Facilitate",

  // ── CATEGORISED CONDITIONS (dental-specific) ──────
  categorisedConditions: [
    {
      category: "Dental Implants & Restorative Dentistry",
      icon: "🦷",
      color: "blue",
      items: [
        {
          name: "Single & Multiple Dental Implants",
          desc: "High-quality titanium or zirconia implants to replace missing teeth.",
        },
        {
          name: "Full-Mouth Rehabilitation",
          desc: "Comprehensive reconstruction for severely decayed or worn-out teeth, using implants, bridges, or overdentures.",
        },
        {
          name: "All-on-4 / All-on-6 Implants",
          desc: "Full arch restorations fixed on a minimal number of implants, frequently completed in one or two visits.",
        },
        {
          name: "Crowns & Bridges",
          desc: "Ceramic, porcelain, or zirconia caps to strengthen damaged teeth or replace gaps.",
        },
      ],
    },
    {
      category: "Cosmetic Dentistry & Smile Design",
      icon: "✨",
      color: "amber",
      items: [
        {
          name: "Porcelain Veneers & Smile Makeover",
          desc: "Ultra-thin porcelain shells bonded to the front surface of teeth for an instant smile transformation.",
        },
        {
          name: "Zirconia & Ceramic Crowns",
          desc: "Metal-free, natural-looking crowns with superior strength and aesthetics.",
        },
        {
          name: "Teeth Whitening & Bleaching",
          desc: "Professional in-chair laser whitening and take-home bleaching kits for a brighter smile.",
        },
      ],
    },
    {
      category: "Orthodontics",
      icon: "📐",
      color: "violet",
      items: [
        {
          name: "Clear Aligners (Invisalign)",
          desc: "Discreet, removable aligners heavily favoured by travelling patients for straightening teeth.",
        },
        {
          name: "Ceramic Braces",
          desc: "Cost-effective tooth-coloured braces for a more aesthetic orthodontic option.",
        },
      ],
    },
    {
      category: "Endodontics & Periodontics",
      icon: "🔬",
      color: "green",
      items: [
        {
          name: "Root Canal Treatment (RCT)",
          desc: "Modern single-sitting or multi-sitting painless root canals utilising digital X-rays and lasers.",
        },
        {
          name: "Periodontal (Gum) Disease Treatment",
          desc: "Specialised care including flap surgery, laser gum contouring, and LANAP.",
        },
      ],
    },
    {
      category: "Oral & Maxillofacial Surgery",
      icon: "🏥",
      color: "rose",
      items: [
        {
          name: "Wisdom Tooth Extraction",
          desc: "Routine or complex surgical removal of impacted wisdom teeth.",
        },
        {
          name: "Jaw Surgery (Orthognathic Surgery)",
          desc: "Corrective procedures for jaw alignment, temporomandibular joint disorders or facial trauma.",
        },
        {
          name: "Cleft Palate Dental Rehabilitation",
          desc: "Specialised multi-disciplinary dental rehabilitation for patients with cleft palate.",
        },
      ],
    },
  ],

  // flat list kept for the stay banner & legacy use
  conditions: [
    "Missing Teeth — Single & Multiple Implants",
    "Full Mouth Rehabilitation",
    "All-on-4 & All-on-6 Implant Bridges",
    "Porcelain Veneers & Smile Makeover",
    "Zirconia & Ceramic Crowns",
    "Root Canal Treatment",
    "Periodontal (Gum) Disease Treatment",
    "Teeth Whitening & Bleaching",
    "Invisalign & Ceramic Braces",
    "Wisdom Tooth Extraction",
    "Jaw Surgery (Orthognathic Surgery)",
    "Cleft Palate Dental Rehabilitation",
  ],

  // ── UPDATED STAY VALUE ────────────────────────────
  stayValue:
    "Simple procedures: 3–5 days · Smile makeover & crowns: 7–10 days · Full mouth rehabilitation: 14–21 days (Multiple visits may be needed for implants depending on Requirements) · All-on-4 implants: 5–7 days (first visit) + 3–5 days (final bridge visit)",

  costTitle: "Why India for Dental Treatment?",
  costRows: [
    {
      procedure: "Single Dental Implant (Nobel Biocare)",
      india: "$420–$720",
      africa: "$1,500–$3,000",
      ukusa: "$3,000–$6,000",
    },
    {
      procedure: "All-on-4 Full Arch Implants",
      india: "$3,000–$4,800",
      africa: "$8,000–$15,000",
      ukusa: "$15,000–$28,000",
    },
    {
      procedure: "Porcelain Veneer (per tooth)",
      india: "$145–$240",
      africa: "$400–$900",
      ukusa: "$1,000–$2,500",
    },
    {
      procedure: "Zirconia Crown (per tooth)",
      india: "$95–$220",
      africa: "$300–$800",
      ukusa: "$1,000–$2,000",
    },
    {
      procedure: "Full Mouth Rehabilitation",
      india: "$1,800–$4,800",
      africa: "$8,000–$20,000",
      ukusa: "$20,000–$50,000",
    },
  ],
};

const DentalPage = () => {
  return (
    <TreatmentTemplateForDental
      treatment={DENTAL_TREATMENT}
      paxgrowData={DENTAL_PAXGROW}
    />
  );
};

export default DentalPage;